import script from "./ThuChiAdminList.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiAdminList.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiAdminList.vue?vue&type=style&index=0&id=61adb488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61adb488"]])

export default __exports__